import AbstractService from "./AbstractService";

export default class EmployeeService extends AbstractService {
  url(url) {
    return `/employee${url}`;
  }

  findAll(query, include, embed, page, perPage, field, ascending) {
    const q = Object.assign({}, query);
    const params = this.getParams(
      q,
      include,
      embed,
      page,
      perPage,
      field,
      ascending
    );
    return this.http.get(this.url("/getAll"), {
      params
    });
  }
  
  findAllUnderCharge(reference, query, include, embed, page, perPage, field, ascending) {
    const q = Object.assign({}, query);
  
    const params = this.getParams(
      q,
      include,
      embed,
      page,
      perPage,
      field,
      ascending
    );
    return this.http.get(this.url(`/underCharge/${reference}`), {
      params
    });
  }

  editEmployee(reference, body) {
    return this.http.put(this.url(`/query/${reference}`), body);
  }

  _modelToQuery(model) {
    const query = Object.assign({}, model);
    return query;
  }
}
